var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"fullLoading"},[_c('div',{attrs:{"id":"nprogress"}},[_c('div',{ref:"bar",staticClass:"bar",staticStyle:{"display":"block"},attrs:{"role":"bar"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }